import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { restoreScoreDraft, scoreDraftPath } from '../utils/scoreDraft';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useResumeScoreDraft = ({ enabled, userId, draftId, onRestore }) => {
  const restore = useRef(onRestore);
  restore.current = onRestore;
  const [state, setState] = useState({ status: 'loading', error: '', legacy: false, courseUnavailable: false });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    setState({ status: 'loading', error: '', legacy: false, courseUnavailable: false });
    (async () => {
      try {
        const { data } = await axios.get(`${API}${scoreDraftPath(draftId)}`, { signal: controller.signal, timeout: 20000 });
        let course = null, courseUnavailable = false;
        if (data.course_id) {
          try {
            const response = await axios.get(`${API}/courses/${encodeURIComponent(data.course_id)}`, { signal: controller.signal, timeout: 15000 });
            course = response.data;
          } catch { courseUnavailable = true; }
        }
        const restored = restoreScoreDraft(data, course);
        if (controller.signal.aborted) return;
        restore.current(restored);
        setState({ status: 'ready', error: '', legacy: restored.legacy, courseUnavailable });
      } catch (error) {
        if (!controller.signal.aborted) setState({ status: 'error', error: error.response ? 'Unable to load your saved round. Please try again.' : error.message || 'Unable to load your saved round.' });
      }
    })();
    return () => controller.abort();
  }, [enabled, userId, draftId, attempt]);
  return { ...state, retry: () => setAttempt(value => value + 1) };
};